import React from 'react'

import * as S from './styles'

/**
 * @typedef {'filled' | 'outline' | 'light' | 'white' | 'default' | 'subtle' | 'gradient'} VariantType
 */

/**
 * @typedef {Object} BotaoProps
 * @property {VariantType} [variant]
 * @property {string} label
 * @property {boolean} [disabled]
 * @property {boolean} [loading]
 * @property {boolean} [compact]
 * @property {boolean} [uppercase]
 * @property {React.ReactNode} [leftIcon]
 * @property {React.ReactNode} [rightIcon]
 * @property {React.CSSProperties} [style]
 * @property {string | number} [width]
 * @property {() => void} [onClick]
 */

/**
 * @param {BotaoProps} props
 */
export default function Botao({
  variant = 'primary',
  label,
  disabled,
  loading,
  compact,
  uppercase = true,
  onClick,
  style,
  width,
  leftIcon,
  rightIcon
}) {
  return (
    <S.Button
      w={width}
      style={style}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      onClick={onClick}
      uppercase={uppercase}
      compact={compact}
      disabled={disabled}
      variant={variant}
      loading={loading}
      loaderPosition="right"
      loaderProps={{
        size: 'sm'
      }}
    >
      {label}
    </S.Button>
  )
}
